// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {atom, computed} from 'nanostores';

const $raw = atom([]);

export const $crumbs = computed($raw, raw=>{
    const res = [...raw];
    res.sort((a, b)=>a.id - b.id);
    return res;
});

export const push = crumb=>{
    $raw.set($raw.value.concat(crumb));
};

export const remove = id=>{
    $raw.set($raw.value.filter(c=>c.id!=id));
};

export const replace = (id, crumb)=>{
    $raw.set($raw.value.map(c=>{
        if (c.id==id)
            return crumb;
        return c;
    }));
};
